import { getRidersSessionIdFromCookie, setCookie } from "./cookies";
import { isLocal } from "./isLocal";
import { getRidersLoginUrl } from "./getUrl";

export const handleRidersLogin = () => {
  return new Promise((resolve, reject) => {
    if (isLocal) {
      resolve(true);
      return;
    }
    // If there is no riders session id in the cookie, redirect to the login page
    const ridersSessionId = getRidersSessionIdFromCookie();
    if (!ridersSessionId) {
      setCookie(
        "force-public-next",
        window.location.href,
        { domain: ".riders.ai" }
      );
      const loginUrl = getRidersLoginUrl();
      const redirectUrl = `https://${loginUrl}/auth/login?force_redirect=true`;
      console.log("Redirecting to login page", redirectUrl);
      window.location.href = redirectUrl;
    } else {
      resolve(true);
    }
  });
}